import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-533bb862")
const _hoisted_1 = { class: "px-8 border-end border-2 d-flex align-items-center justify-content-center min-w-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "me-5" }, " Filter By Sales Channel: ", -1)
const _hoisted_3 = { class: "btn-group filter-dropdown" }
const _hoisted_4 = {
  class: "btn btn-sm dropdown-toggle d-flex justify-content-between align-items-center",
  type: "button",
  id: "channel-filter-dropdown",
  "data-bs-toggle": "dropdown",
  "data-bs-auto-close": "outside",
  "aria-expanded": "false"
}
const _hoisted_5 = { class: "dropdown-menu py-0 rounded overflow-hidden mt-n1" }
const _hoisted_6 = { class: "menu-item px-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-0" }, null, -1)
const _hoisted_8 = ["value", "disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-0" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", _hoisted_4, _toDisplayString(_ctx.selected), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allUserChannels, (channel, index) => {
            return (_openBlock(), _createElementBlock("label", {
              key: index,
              class: "mo-list-group-item d-flex form-check form-switch metronic-dropdown-item menu-link fs-6 metronic-dropdown-text"
            }, [
              _withDirectives(_createElementVNode("input", {
                value: channel,
                class: "form-check-input form-check-custom form-check-blue checkbox m-0 me-4",
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.checkedChannels = $event)),
                disabled: _ctx.isLastCheckedItem(channel)
              }, null, 8, _hoisted_8), [
                [_vModelCheckbox, _ctx.checkedChannels]
              ]),
              _createTextVNode(" " + _toDisplayString(channel), 1)
            ]))
          }), 128)),
          _hoisted_9
        ])
      ])
    ])
  ]))
}